import { Navigate } from "react-router-dom";
import { useRouteParams } from "src/hooks/useRouteParams";
import { PlanPackageDetailsParams } from "src/routes/routesDef";
import { planPackageRoute } from "src/routing/domains/librariesPaths";

/** Forwards legacy `/libraries/plan/:planPackageId/*` details links to the plan package page. */
export function PlanPackagePage() {
  const { planPackageId, planPackageVersionId } = useRouteParams<PlanPackageDetailsParams>();
  return <Navigate to={planPackageRoute.url({ planPackageId, planPackageVersionId })} replace />;
}
